import "./skeletonPage.scss"
import SkeletonElement from "../SkeletonElement/SkeletonElement";
import SkeletonPoster from "../SkeletonPoster/SkeletonPoster";

const SkeletonPage = () => {
	return (
		<div className="Skeleton__Page" style={{padding:5}}>
			<SkeletonElement type="title" />
			<SkeletonPoster/>
			<SkeletonElement type="title" />
			<SkeletonPoster/>
			
		</div>
	);
};

export default SkeletonPage;